import styled from "styled-components";

export const Container = styled.div`
	position: relative;
`;
export const CountChat = styled.div`
	position: absolute;
	bottom: -6px;
	right: -5px;
	background: red;
	color: white;
	width: 16px;
	height: 16px;
	border-radius: 50%;
	font-size: 0.7rem;
	display: flex;
	align-items: center;
	justify-content: center;
	user-select: none;
`;

export const AreaToolltipLastComment = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.4rem;
	white-space: pre-wrap;
`;
